export function headerFunc() {
  console.log('ヘッダーで使うJS');
}

export function headerScrFunc() {
  let anniversaryIndex = $('#anniversaryIndex').length;
    
     if (anniversaryIndex) {
         const header = document.getElementById("header");
         
         const aboutBtn = $('#aboutBtn');
         const aboutContent = $('#aboutMenu');
         const megaMenu = $('.megaMenu');
         const megaMenuBg = $('#megaMenuBg');
         let mainKvHeight = $('.mainKv').outerHeight();
         
         const navBtn = $('#navBtn');
         const navMenu = $('#navMenu');
         
         let scrollPosition;
         let menuOpenFlg = 0;
         let scrTopFlg = 0;
         scrTopFlg = 1;
         
         aboutBtn.on({
             'mouseenter': function () {
                 aboutContent.addClass('isShow');
                 header.classList.remove('changeColor');
                 if (megaMenuBg.hasClass('isShow')) {
                     aboutContent.addClass('isFast');
                 } else {
                     megaMenuBg.addClass('isShow');
                 }
             }
         });
         
         $(".pcGlobalNav>ul>li:not('#aboutBtn')").on('mouseover', function () {
             aboutContent.removeClass('isShow');
         });
         
         $("main,.headerLogo").on('mouseover', function () {
             megaMenu.removeClass('isShow');
             megaMenu.removeClass('isFast');
             megaMenuBg.removeClass('isShow');
             if (scrTopFlg == 1) {
                 header.classList.add('changeColor');
             }
         });

         document.body.addEventListener("mouseleave", () => {
             megaMenu.removeClass('isShow');
             megaMenu.removeClass('isFast');
             megaMenuBg.removeClass('isShow');
             if (scrTopFlg == 1) {
                 header.classList.add('changeColor');
             }
         }, false);

         document.addEventListener("mousewheel", () => {
             megaMenu.removeClass('isShow');
             megaMenu.removeClass('isFast');
             megaMenuBg.removeClass('isShow');
             if (scrTopFlg == 1 && menuOpenFlg == 0) {
                 header.classList.add('changeColor');
             }
         });
         document.addEventListener("touchmove", () => {
             megaMenu.removeClass('isShow');
             megaMenu.removeClass('isFast');
             megaMenuBg.removeClass('isShow');
             if (scrTopFlg == 1 && menuOpenFlg == 0) {
                 header.classList.add('changeColor');
             }
         });
         
         $(window).resize(function () {
             mainKvHeight
         });

         $(window).on('scroll', function () {
             let scrTop = $(window).scrollTop();
             if (menuOpenFlg == 0) {
                 if (scrTop < mainKvHeight) {
                     scrTopFlg = 1;
                     header.classList.add('changeColor');
                     header.classList.remove('isShow');
                 } else {
                     scrTopFlg = 0;
                     header.classList.remove('changeColor');
                     header.classList.add('isShow');
                 }
             }
         });
         
         navBtn.on('click', function () {
             navBtn.toggleClass('isOpen');
             if (navBtn.hasClass('isOpen')) {
                 scrollPosition = $(window).scrollTop();
                 menuOpenFlg = 1;
                 navMenu.addClass('isShow');
                 header.classList.remove('changeColor');
                 $('body').addClass('fixedBody').css({
                     'top': -scrollPosition
                 });
             } else {
                 menuOpenFlg = 0;
                 navMenu.removeClass('isShow');
                 $('body').removeClass('fixedBody').css({
                     'top': 0
                 });
                 window.scrollTo(0, scrollPosition);
                 if (scrTopFlg == 1) {
                     header.classList.add('changeColor');
                 }
             }
         });
    }
}